var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { PARAMS, getAuthConfig } from "../config";
import { getPasswordResetRequirement, getOnLoginBioAuthRequirements } from "../helperFunctions";
export function AuthenticateFactory(useAuthContext) {
    return function Authenticate(_a) {
        var children = _a.children, loadingComponent = _a.loadingComponent;
        var _b = useAuthContext(), isLoading = _b.isLoading, isAuthenticated = _b.isAuthenticated, user = _b.user;
        var _c = getAuthConfig(), loginPageUrl = _c.loginUrl, bioAuthUrl = _c.bioAuthUrl, passwordResetUrl = _c.passwordResetUrl;
        useEffect(function () {
            if (!isAuthenticated && !isLoading) {
                if (loginPageUrl.match(/^https?:\/\//)) {
                    window.location.href = loginPageUrl + "?" + PARAMS.redirect + "=" + window.location.href;
                }
                else {
                    window.location.href = window.location.origin + loginPageUrl + "?" + PARAMS.redirect + "=" + window.location.href;
                }
                return;
            }
        }, [isLoading, isAuthenticated, loginPageUrl]);
        if (isLoading || !isAuthenticated || !user) {
            // Loading indication is shown while redirecting
            return _jsx(_Fragment, { children: loadingComponent || _jsx("span", __assign({ role: "status" }, { children: "Authenticating..." }), void 0) }, void 0);
        }
        var passwordResetRequirement = getPasswordResetRequirement(user);
        var onLoginBioAuthRequirements = getOnLoginBioAuthRequirements(user);
        if (passwordResetRequirement) {
            var params = PARAMS.password_reset_token + "=" + passwordResetRequirement.resetToken + "&" + PARAMS.redirect + "=" + window.location.href;
            if (passwordResetUrl.match(/^https?:\/\//)) {
                window.location.href = passwordResetUrl + "?" + params;
            }
            else {
                window.location.href = window.location.origin + passwordResetUrl + "?" + params;
            }
            return _jsx(_Fragment, { children: loadingComponent || _jsx("span", __assign({ role: "status" }, { children: "Authenticating..." }), void 0) }, void 0);
        }
        if (!onLoginBioAuthRequirements) {
            return _jsx(_Fragment, { children: children }, void 0);
        }
        if (bioAuthUrl.match(/^https?:\/\//)) {
            window.location.href = bioAuthUrl + "?" + PARAMS.redirect + "=" + window.location.href;
        }
        else {
            window.location.href = window.location.origin + bioAuthUrl + "?" + PARAMS.redirect + "=" + window.location.href;
        }
        return _jsx(_Fragment, { children: loadingComponent || _jsx("span", __assign({ role: "status" }, { children: "Authenticating..." }), void 0) }, void 0);
    };
}
export default AuthenticateFactory;
